import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Logger, LoggerFactory } from '../../../core/logger.service';

@Component({
  selector: 'app-button-with-progress',
  templateUrl: './button-with-progress.component.html',
  styleUrls: ['./button-with-progress.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ButtonWithProgressComponent implements OnInit {
  public settings: ButtonSettings;
  private readonly logger: Logger;

  constructor(loggerFactory: LoggerFactory) {
    this.settings = new ButtonSettings();
    this.logger = loggerFactory.get('ButtonWithProgressComponent');
  }

  ngOnInit() {}

  @Input()
  set text(text: string) {
    this.settings.text = text;
  }

  @Input()
  set inProgress(inProgress: boolean) {
    if (inProgress !== undefined) {
      this.settings.inProgress = inProgress;
    }
  }
  get inProgress() {
    return this.settings.inProgress;
  }

  @Input()
  set buttonColor(color: string) {
    if (!color || ['primary', 'accent'].indexOf(color.toLowerCase()) === -1) {
      this.logger.error('Non-allowed color chosen on button: ' + color);
      return;
    }
    this.settings.buttonColor = color;
  }

  @Input()
  set spinnerColor(color: string) {
    if (!color || ['primary', 'accent'].indexOf(color.toLowerCase()) === -1) {
      this.logger.error('Non-allowed color chosen on spinner: ' + color);
      return;
    }
    this.settings.spinnerColor = color;
  }

  @Input()
  set btnType(type: string) {
    if (!type || ['basic', 'raised', 'stroked', 'flat'].indexOf(type.toLowerCase()) === -1) {
      this.logger.error('Non-allowed type chosen on button: ' + type);
      return;
    }
    this.settings.type = type;
  }

  @Input()
  set disabled(disabled: boolean) {
    if (disabled !== undefined) {
      this.settings.disabled = disabled;
    }
  }

  @Input()
  set fullWidth(fullWidth: boolean) {
    if (fullWidth !== undefined) {
      this.settings.fullWidth = fullWidth;
    }
  }

  @Input()
  set minHeight(minHeight: number) {
    if (minHeight !== undefined) {
      this.settings.minHeight = minHeight;
      this.settings.spinnerSize = Math.round(0.5 * minHeight);
    }
  }

  @Input()
  set buttonClass(buttonClass: string) {
    if (buttonClass !== undefined) {
      this.settings.buttonClass = buttonClass;
    }
  }

  @Input()
  set icon(icon: string) {
    if (icon !== undefined) {
      this.settings.icon = icon;
    }
  }

  @Input()
  set img(img: string) {
    if (img !== undefined) {
      this.settings.img = img;
    }
  }
}

class ButtonSettings {
  inProgress = false;
  text: string;
  buttonColor: string;
  spinnerColor: string;
  type = 'raised';
  /*raised?: boolean;
  stroked?: boolean;*/
  /* Spinner modes: determinate and indeterminate*/
  mode = 'indeterminate';
  disabled = false;
  fullWidth = false;
  minHeight = 24;
  spinnerSize = 18;
  buttonClass = 'primary-button';
  icon = undefined;
  img = undefined;
}
